import React from 'react';
var ExternalLink = function ExternalLink(props) { return /*#__PURE__*/ React.createElement("a", Object.assign({}, props, { target: "_blank", rel: "noreferrer" })); };
export default ExternalLink;
